"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _classnames = _interopRequireDefault(require("classnames"));

var _Ripple = _interopRequireDefault(require("./components/Ripple"));

var _TwinPulse = _interopRequireDefault(require("./components/TwinPulse"));

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Loader = function Loader(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["height", "width"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('loader', classes.Loader),
    style: {
      height: height,
      width: width
    }
  }, rest));
};

exports["default"] = Loader;
Loader.Ripple = _Ripple["default"];
Loader.TwinPulse = _TwinPulse["default"];
//# sourceMappingURL=index.js.map